/* ============================================================
   ESTILISTAS WIDGET — stylists-widget.js
   Instalar en: Assets del tema → stylists-widget.js
   Referenciar en theme.liquid (antes de </body>) con:
   <script src="{{ 'stylists-widget.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ── CONFIGURACIÓN ─────────────────────────────────────────
     Ajusta estos valores sin tocar el resto del código.
  ─────────────────────────────────────────────────────────── */
  const CONFIG = {
    // URL del Web App de Google Apps Script (reemplazar al desplegar)
    webhookUrl: 'https://script.google.com/macros/s/AKfycbw7yzUPEalmos9PE2Vzv77DQdBFjL08flj8nc8wOO80WPglOwx7zIAJmrDM2KGIrame/exec',

    // Clave pública de Cloudflare Turnstile
    // Obtener en: https://dash.cloudflare.com → Turnstile
    turnstileSiteKey: '0x4AAAAAADpaOiIGUOJ-ODOh',

    // Número de WhatsApp del negocio (sin + ni espacios)
    whatsappNumber: '573206418316',

    // Texto personalizable del botón flotante
    floatBtnText: '¿Eres estilista?',

    // Autoabrir modal tras N segundos (0 = desactivado)
    autoOpenDelay: 0,
  };

  /* ── ESTADO INTERNO ──────────────────────────────────────── */
  const state = {
    isOpen: false,
    isSubmitting: false,
    turnstileToken: null,
    turnstileWidgetId: null,
  };

  /* ── UTILIDADES ──────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  const isValidEmail = (v) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());

  const isValidPhone = (v) =>
    /^\+?[\d\s\-().]{7,20}$/.test(v.trim());

  const sanitize = (str) =>
    String(str).trim().replace(/[<>"'`]/g, (c) => ({ '<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','`':'&#96;' }[c]));

  /* ── INYECCIÓN DEL HTML ──────────────────────────────────── */
  function injectHTML () {
    const html = `
      <!-- Botón flotante -->
      <div id="sw-floating-buttons">

        <a
        id="sw-whatsapp-btn"
        href="https://wa.me/573206418316?text=Hola%2C%20vengo%20de%20inoar.co%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20productos."
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        >
      </a>

        <button id="sw-float-btn" class="sw-pulsing">
          <svg viewBox="0 0 24 24">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          ${sanitize(CONFIG.floatBtnText)}
        </button>

      </div>

      <!-- Overlay + Modal -->
      <div id="sw-overlay" role="dialog" aria-modal="true" aria-labelledby="sw-modal-title">
        <div id="sw-modal">

          <div class="sw-modal-header">
            <div class="sw-modal-header-text">
              <h2 id="sw-modal-title">Únete como estilista</h2>
              <p>Déjanos tus datos y te contactamos con más información.</p>
            </div>
            <button id="sw-close-btn" aria-label="Cerrar">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <div class="sw-modal-body">

            <!-- Formulario principal -->
            <form id="sw-form" novalidate autocomplete="on">

              <!-- Campo Honeypot (anti-bot, invisible) -->
              <div class="sw-hp-field" aria-hidden="true">
                <label for="sw-hp-name">Dejar en blanco</label>
                <input type="text" id="sw-hp-name" name="sw_website" tabindex="-1" autocomplete="off">
              </div>

              <!-- Nombre completo -->
              <div class="sw-field" id="sw-field-nombre">
                <label for="sw-nombre">
                  Nombre completo <span class="sw-required" aria-hidden="true">*</span>
                </label>
                <input
                  type="text"
                  id="sw-nombre"
                  name="nombre"
                  placeholder="Ej. María González"
                  autocomplete="name"
                  required
                  maxlength="100"
                >
                <span class="sw-error-msg" role="alert" id="sw-error-nombre">
                  ⚠ Por favor ingresa tu nombre completo.
                </span>
              </div>

              <!-- Fila: Celular + Ciudad -->
              <div class="sw-field-row">
                <div class="sw-field" id="sw-field-celular">
                  <label for="sw-celular">
                    Celular <span class="sw-required" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="tel"
                    id="sw-celular"
                    name="celular"
                    placeholder="Ej. 3001234567"
                    autocomplete="tel"
                    required
                    maxlength="20"
                    inputmode="tel"
                  >
                  <span class="sw-error-msg" role="alert" id="sw-error-celular">
                    ⚠ Ingresa un celular válido (solo números).
                  </span>
                </div>

                <div class="sw-field" id="sw-field-ciudad">
                  <label for="sw-ciudad">
                    Ciudad <span class="sw-required" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="sw-ciudad"
                    name="ciudad"
                    placeholder="Ej. Bogotá"
                    autocomplete="address-level2"
                    required
                    maxlength="80"
                  >
                  <span class="sw-error-msg" role="alert" id="sw-error-ciudad">
                    ⚠ Por favor ingresa tu ciudad.
                  </span>
                </div>
              </div>

              <!-- Correo electrónico -->
              <div class="sw-field" id="sw-field-correo">
                <label for="sw-correo">
                  Correo electrónico <span class="sw-required" aria-hidden="true">*</span>
                </label>
                <input
                  type="email"
                  id="sw-correo"
                  name="correo"
                  placeholder="Ej. maria@correo.com"
                  autocomplete="email"
                  required
                  maxlength="120"
                  inputmode="email"
                >
                <span class="sw-error-msg" role="alert" id="sw-error-correo">
                  ⚠ Ingresa un correo electrónico válido.
                </span>
              </div>

              <!-- Nombre del salón (opcional) -->
              <div class="sw-field" id="sw-field-salon">
                <label for="sw-salon">
                  Nombre del salón o negocio
                  <span class="sw-optional">(opcional)</span>
                </label>
                <input
                  type="text"
                  id="sw-salon"
                  name="salon"
                  placeholder="Ej. Studio Glam"
                  maxlength="120"
                >
              </div>

              <!-- Comentarios (opcional) -->
              <div class="sw-field" id="sw-field-comentarios">
                <label for="sw-comentarios">
                  Comentarios
                  <span class="sw-optional">(opcional)</span>
                </label>
                <textarea
                  id="sw-comentarios"
                  name="comentarios"
                  placeholder="¿Algo que quieras contarnos?"
                  maxlength="500"
                  rows="3"
                ></textarea>
              </div>

              <!-- Cloudflare Turnstile -->
              <div id="sw-captcha-wrapper"></div>

              <!-- Botón enviar -->
              <button type="submit" id="sw-submit-btn">
                <div class="sw-spinner" aria-hidden="true"></div>
                <span class="sw-btn-text">Enviar información</span>
              </button>

            </form>

            <!-- Mensaje de feedback post-envío -->
            <div id="sw-feedback" aria-live="polite"></div>

          </div><!-- /.sw-modal-body -->
        </div><!-- /#sw-modal -->
      </div><!-- /#sw-overlay -->
    `;

    const container = document.createElement('div');
    container.innerHTML = html;
    document.body.appendChild(container);
  }

  /* ── CLOUDFLARE TURNSTILE ────────────────────────────────── */
  function loadTurnstile () {
    // Cargar script de Turnstile si no está ya
    if (!document.getElementById('sw-turnstile-script')) {
      const script = document.createElement('script');
      script.id   = 'sw-turnstile-script';
      script.src  = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=swTurnstileReady';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  // Callback global invocado por Turnstile al cargar
  window.swTurnstileReady = function () {
    const wrapper = document.getElementById('sw-captcha-wrapper');
    if (!wrapper || !window.turnstile) return;

    state.turnstileWidgetId = window.turnstile.render(wrapper, {
      sitekey: CONFIG.turnstileSiteKey,
      theme: 'light',
      callback: (token) => { state.turnstileToken = token; },
      'expired-callback': () => { state.turnstileToken = null; },
      'error-callback':   () => { state.turnstileToken = null; },
    });
  };

  /* ── APERTURA / CIERRE DEL MODAL ─────────────────────────── */
  function openModal () {
    if (state.isOpen) return;
    state.isOpen = true;
    const overlay = document.getElementById('sw-overlay');
    const floatBtn = document.getElementById('sw-float-btn');
    overlay.classList.add('sw-open');
    floatBtn.classList.remove('sw-pulsing');
    document.body.style.overflow = 'hidden';

    // Foco accesible al título
    setTimeout(() => {
      const title = document.getElementById('sw-modal-title');
      if (title) title.focus?.();
    }, 300);
  }

  function closeModal () {
    if (!state.isOpen) return;
    state.isOpen = false;
    document.getElementById('sw-overlay').classList.remove('sw-open');
    document.body.style.overflow = '';
  }

  /* ── VALIDACIÓN DEL FORMULARIO ───────────────────────────── */
  const RULES = {
    nombre:      { validate: (v) => v.trim().length >= 3,  field: 'sw-field-nombre' },
    celular:     { validate: isValidPhone,                  field: 'sw-field-celular' },
    correo:      { validate: isValidEmail,                  field: 'sw-field-correo' },
    ciudad:      { validate: (v) => v.trim().length >= 2,  field: 'sw-field-ciudad' },
  };

  function clearErrors () {
    Object.values(RULES).forEach(({ field }) => {
      document.getElementById(field)?.classList.remove('sw-has-error');
    });
  }

  function validateForm (data) {
    let valid = true;
    clearErrors();

    for (const [key, rule] of Object.entries(RULES)) {
      if (!rule.validate(data[key] ?? '')) {
        document.getElementById(rule.field)?.classList.add('sw-has-error');
        valid = false;
      }
    }
    return valid;
  }

  /* ── CONSTRUCCIÓN DEL MENSAJE WHATSAPP ───────────────────── */
  function buildWhatsAppURL (data) {
    const msg = [
      'Hola, soy estilista.',
      '',
      `Nombre: ${data.nombre}`,
      `Celular: ${data.celular}`,
      `Correo: ${data.correo}`,
      `Ciudad: ${data.ciudad}`,
      data.salon ? `Salón: ${data.salon}` : null,
      data.comentarios ? `\nComentarios: ${data.comentarios}` : null,
      '',
      'Quiero recibir más información.',
    ]
      .filter((l) => l !== null)
      .join('\n');

    return `https://wa.me/${CONFIG.whatsappNumber}?text=${encodeURIComponent(msg)}`;
  }

  /* ── MOSTRAR FEEDBACK ────────────────────────────────────── */
  function showFeedback ({ success, title, message }) {
    const form     = document.getElementById('sw-form');
    const feedback = document.getElementById('sw-feedback');

    form.style.display = 'none';
    feedback.className = 'sw-visible';

    const iconClass = success ? 'sw-success-icon' : 'sw-error-icon';
    const iconPath  = success
      ? '<polyline points="20 6 9 17 4 12"/>'
      : '<line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>';

    feedback.innerHTML = `
      <div class="sw-feedback-icon ${iconClass}">
        <svg viewBox="0 0 24 24" aria-hidden="true">${iconPath}</svg>
      </div>
      <p><strong>${sanitize(title)}</strong>${sanitize(message)}</p>
    `;
  }

  /* ── ENVÍO DEL FORMULARIO ────────────────────────────────── */
  async function handleSubmit (e) {
    e.preventDefault();
    if (state.isSubmitting) return;

    const form = e.target;

    /* Recolectar datos */
    const data = {
      nombre:       form.querySelector('#sw-nombre').value,
      celular:      form.querySelector('#sw-celular').value,
      correo:       form.querySelector('#sw-correo').value,
      ciudad:       form.querySelector('#sw-ciudad').value,
      salon:        form.querySelector('#sw-salon').value,
      comentarios:  form.querySelector('#sw-comentarios').value,
      honeypot:     form.querySelector('#sw-hp-name').value,
      turnstile:    state.turnstileToken ?? '',
    };

    /* Validar campos obligatorios */
    if (!validateForm(data)) {
      // Scroll al primer campo con error
      const firstError = form.querySelector('.sw-has-error input, .sw-has-error textarea');
      firstError?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstError?.focus();
      return;
    }

    /* Verificar Turnstile solo en producción (si la clave está configurada) */
    if (CONFIG.turnstileSiteKey !== 'TU_TURNSTILE_SITE_KEY' && !data.turnstile) {
      alert('Por favor completa la verificación de seguridad.');
      return;
    }

    /* Estado de carga */
    state.isSubmitting = true;
    const submitBtn = document.getElementById('sw-submit-btn');
    submitBtn.disabled = true;
    submitBtn.classList.add('sw-loading');

    try {
      const formData = new FormData();

      formData.append('nombre', data.nombre.trim());
      formData.append('celular', data.celular.trim());
      formData.append('correo', data.correo.trim());
      formData.append('ciudad', data.ciudad.trim());
      formData.append('salon', data.salon.trim());
      formData.append('comentarios', data.comentarios.trim());
      formData.append('honeypot', data.honeypot);
      formData.append('captcha', data.turnstile);
      formData.append('origen', window.location.href);

      const response = await fetch(CONFIG.webhookUrl, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const result = await response.json();

      if (result.success) {
        /* Mostrar mensaje de éxito */
        showFeedback({
          success: true,
          title: '¡Registro exitoso! 🎉',
          message: ' En un momento te redirigimos a WhatsApp para continuar.',
        });

        /* Abrir WhatsApp tras breve pausa */
        setTimeout(() => {
          window.open(buildWhatsAppURL(data), '_blank', 'noopener,noreferrer');
        }, 1800);

      } else {
        throw new Error(result.message || 'Error del servidor');
      }

    } catch (err) {
      console.error('[SW] Error al enviar:', err);
      showFeedback({
        success: false,
        title: 'Ocurrió un problema',
        message: ' No pudimos enviar tu información. Por favor intenta de nuevo.',
      });

      /* Restaurar formulario para reintento */
      setTimeout(() => {
        const form     = document.getElementById('sw-form');
        const feedback = document.getElementById('sw-feedback');
        form.style.display     = '';
        feedback.className     = '';
        feedback.innerHTML     = '';
        submitBtn.disabled     = false;
        submitBtn.classList.remove('sw-loading');
        state.isSubmitting     = false;

        /* Reiniciar Turnstile */
        if (state.turnstileWidgetId !== null && window.turnstile) {
          window.turnstile.reset(state.turnstileWidgetId);
          state.turnstileToken = null;
        }
      }, 3500);
      return;
    }

    state.isSubmitting = false;
  }

  /* ── MANEJO DEL TECLADO (accesibilidad) ─────────────────── */
  function handleKeydown (e) {
    if (e.key === 'Escape' && state.isOpen) closeModal();
  }

  /* ── TRAP FOCUS DENTRO DEL MODAL ────────────────────────── */
  function trapFocus (e) {
    if (!state.isOpen) return;
    const modal = document.getElementById('sw-modal');
    if (!modal) return;
    const focusable = modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
    );
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    }
  }

  /* ── INICIALIZACIÓN ──────────────────────────────────────── */
  function init () {
    injectHTML();
    loadTurnstile();

    /* Event listeners */
    document.getElementById('sw-float-btn').addEventListener('click', openModal);
    document.getElementById('sw-close-btn').addEventListener('click', closeModal);
    document.getElementById('sw-form').addEventListener('submit', handleSubmit);

    /* Cerrar al hacer clic fuera del modal */
    document.getElementById('sw-overlay').addEventListener('click', (e) => {
      if (e.target === document.getElementById('sw-overlay')) closeModal();
    });

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('keydown', trapFocus);

    /* Auto-abrir si está configurado */
    if (CONFIG.autoOpenDelay > 0) {
      setTimeout(openModal, CONFIG.autoOpenDelay * 1000);
    }

    /* Limpiar error en tiempo real al escribir */
    ['sw-nombre','sw-celular','sw-correo','sw-ciudad'].forEach((id) => {
      document.getElementById(id)?.addEventListener('input', function () {
        this.closest('.sw-field')?.classList.remove('sw-has-error');
      });
    });
  }

  /* Esperar a que el DOM esté listo */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
